import { Box, Divider, Tab, Tabs } from "@material-ui/core";
import * as React from "react";
import { FC } from "react";
import { ListProps } from "react-admin";
import RbhSearch from "./RbhSearch";
import PbhSearch from "./PbhSearch";
import { useVerifyPermission } from "@airborne/react-admin";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const Search: FC<ListProps> = props => {
  useVerifyPermission("customroutes", "search.read");
  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => setTabValue(newValue);

  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <Tabs variant="fullWidth" centered indicatorColor="primary" value={tabValue} onChange={handleChange}>
        <Tab key={0} label="PBH" {...a11yProps(1)} />
        <Tab key={1} label="RBH" {...a11yProps(0)} />
      </Tabs>

      <Divider />
      <Divider />

      <TabPanel value={tabValue} index={0}>
        <PbhSearch />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <RbhSearch />
      </TabPanel>
    </>
  );
};

export default Search;
